// Receives a list object as it is defined by theModel.accountLists in RecordDefModel.js
// Returns a matrix with the content for the list whithout headers
export async function getListContent(list) {
  return await API.get('/lists/'+list.id+'/content')
}

// Returns an array with users
export async function getUsers() {
  return await API.get('/users?state=*')
}

// Returns an array with active users
export async function getActiveUsers() {
  return await API.get('/users?state=A')
}